import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import { ToastProvider } from './Toast';
import enquiriesService from '../../services/enquiriesService';

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [newEnquiriesCount, setNewEnquiriesCount] = useState(0);
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/projects')) return 'Projects Management';
    if (path.includes('/services')) return 'Services Management';
    if (path.includes('/packages')) return 'Packages Management';
    if (path.includes('/gallery')) return 'Gallery Management';
    if (path.includes('/media')) return 'Media & Asset Library';
    if (path.includes('/testimonials')) return 'Testimonials Management';
    if (path.includes('/enquiries')) return 'Client Enquiries';
    if (path.includes('/settings')) return 'Site & Content Settings';
    return 'Dashboard Overview';
  };

  useEffect(() => {
    async function loadEnquiryBadge() {
      try {
        const list = await enquiriesService.getAll();
        const newCount = (list || []).filter((e) => e.status === 'New').length;
        setNewEnquiriesCount(newCount);
      } catch (err) {
        // silent badge fallback
      }
    }
    loadEnquiryBadge();
  }, [location.pathname]);

  return (
    <ToastProvider>
      <div
        className="min-h-screen bg-slate-950 text-slate-100 flex flex-col antialiased"
        style={{ minHeight: '100vh', backgroundColor: '#020617', color: '#f8fafc' }}
      >
        {/* Sidebar */}
        <AdminSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          newEnquiriesCount={newEnquiriesCount}
        />

        {/* Main Content Area */}
        <div className="lg:pl-64 flex flex-col flex-1 min-w-0">
          <AdminHeader
            title={getPageTitle()}
            onMenuClick={() => setSidebarOpen(true)}
          />

          <main className="p-4 sm:p-8 flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </ToastProvider>
  );
}
